import { Pleb } from './Pleb';

interface GroupChatData {
  id: string;
  channelId: string;
  name: string;
  image: string;
  members: Pleb[];
  admins: string[];
  adminPermissionsEnabled: boolean;
}

export class GroupChat {
  id: string;
  channelId: string;
  name: string;
  image: string;
  members: Pleb[];
  admins: string[];
  adminPermissionsEnabled: boolean;

  constructor(data: GroupChatData) {
    this.id = data.id;
    this.channelId = data.channelId;
    this.name = data.name;
    this.image = data.image;
    this.members = data.members;
    this.admins = data.admins;
    this.adminPermissionsEnabled = data.adminPermissionsEnabled;
  }

  static fromJson(json: Record<string, any>, currentUserId?: string): GroupChat {
    const members = (json.members as Array<any>)
      .map(member => Pleb.fromJson(member, currentUserId || '' ))
      .filter(member => member !== null) as Pleb[];
    
    const admins = (json.admins as Array<any>)
      .map(admin => admin as string);

    const adminPermissionsEnabled = admins.includes(currentUserId || '');

    return new GroupChat({
      id: json.id,
      channelId: json.channelId,
      name: json.name,
      image: json.image,
      members,
      admins,
      adminPermissionsEnabled
    });
  }

  copyWith(updates: Partial<GroupChatData>): GroupChat {
    return new GroupChat({
      id: this.id,
      channelId: this.channelId,
      name: this.name,
      image: this.image,
      members: updates.members || this.members,
      admins: this.admins,
      adminPermissionsEnabled: this.adminPermissionsEnabled
    });
  }
}
